<template>
  <v-card>
    <slot name="above-title" />
    <v-card-title>
      {{ title }}
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        @keyup.enter.native="actionClick()"
      >
        <v-text-field
          ref="email"
          v-model="email"
          :value="'@' + domain"
          :disabled="saving"
          :rules="[validateRequired, ...emailRules]"
          label="Email"
          type="email"
          autofocus
          required
          @blur="emailDirty = true"
        />
        <v-text-field
          ref="name"
          v-model="name"
          :disabled="saving"
          :rules="[validateRequired, ...nameRules]"
          label="Name"
          required
          @blur="nameDirty = true"
        />
        <v-alert
          text
          type="info"
        >
          <div v-if="isCounterparty">
            New counter parties will receive an email invitation when you send them a document to sign.
          </div>
          <div v-else>
            We'll send an email notification to the {{ type.toLowerCase() }} telling them they've been added to {{ siteName }} and associated to your account.
          </div>
          <div v-if="isClient">
            Clients that are already registered in {{ siteName }} will be asked if they give permission to share their existing {{ siteName }} data with you. Until they give permission, you won't be able create documents on their behalf.
          </div>
        </v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="allowCancel"
        :disabled="saving"
        color="primary"
        text
        large
        @click.stop="$emit('cancelClick')"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="!valid || !emailValid || !nameValid || saving"
        :loading="saving"
        color="primary"
        large
        @click.stop="actionClick()"
      >
        {{ action }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { siteName } from '../config/app'
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'AddUserForm',
  props: {
    title: { type: String, default: '' },
    type: { type: String, default: '' },
    domain: { type: String, default: '' },
    action: { type: String, default: '' },
    saving: { type: Boolean, default: false },
    allowCancel: { type: Boolean, default: true }
  },
  data: function () {
    return {
      siteName,
      valid: false,
      email: '',
      emailDirty: false,
      name: '',
      nameDirty: false,
      sendInvitation: true,
      emailValidEmail: true,
      clientSendInvitationMessage: 'If this person is already a user, they\'ll still receive a notification that you\'ve linked them to your account.'
    }
  },
  computed: {
    emailRules() {
      var rules = []
      if (this.email && this.type === 'User' && !this.emailValidDomain) {
        rules.push('Email address does not match company domain.')
      } else if (this.emailDirty && !this.emailValidEmail) {
        rules.push('That\'s not a valid email address.')
      } else {
        rules.push(true)
      }
      return rules
    },
    nameRules() {
      var rules = []
      if (this.nameDirty && !this.nameValid) {
        rules.push('Please enter first, middle (if known), and last names.')
      } else {
        rules.push(true)
      }
      return rules
    },
    emailValidDomain() {
      if (this.type === 'Counter Party') {
        return true
      }

      return this.email.includes(this.domain)
    },
    emailValid() {
      return this.emailValidDomain && this.emailValidEmail
    },
    nameValid() {
      return /\w\w+\s\S\w+/.test(this.name)
    },
    isCounterparty() {
      return this.type === 'Counter Party'
    },
    isClient() {
      return this.type === 'Client'
    }
  },
  watch: {
    email: function (email) {
      this.emailValidEmail = this.$refs.email.$refs.input.validity.valid
    }
  },
  methods: {
    validateRequired,
    reset() {
      this.$refs.form.reset()
      Object.assign(this.$data, this.$options.data())

      if (this.domain) {
        this.email = '@' + this.domain
      }
    },
    actionClick() {
      Object.entries(this.$data).forEach(([key, value]) => {
        if (key.includes('Dirty')) {
          this[key] = true
        }
      })

      if (this.$refs.form.validate()) {
        this.$emit('actionClick', { email: this.email, name: this.name, sendInvitation: this.sendInvitation })
      }
    }
  }
}
</script>
